import React from 'react';
import UpWhiteImg from '../../assets/images/up-white.svg';

function SignupBanner() {
  return (
    <div className="h-full text-white mx-auto signup-banner">
      <div style={{ width: 205, minHeight: 45 }}>
        <img
          src={UpWhiteImg}
          alt="urbanpiper"
          className="w-full h-full object-contain"
        />
      </div>

      <div className="signup-text mt-2">SIGN UP TO UNLOCK</div>
      <div className="restaurant-text">Your Restaurant&apos;s</div>
      <div className="unfair-text">Unfair Advantage</div>
    </div>
  );
}

export default SignupBanner;
